export default {
  accountClaimsKey: 'account',
  userClaimsKey: 'sub',
};
